setViewportWidth();

if (viewportWidth > 768) {
  anime.set('.js-halo', {
    opacity: 0,
    scale: 0.5,
  });

  anime.set('.js-blog-thumbnail', {
    opacity: 0,
  });

  const articleTl = anime.timeline({
    easing: 'easeInOutExpo',
  });

  articleTl
    .add({
      targets: '.js-halo',
      opacity: 1,
      scale: 1,
      duration: 1250,
    })
    .add(
      {
        targets: '.js-blog-thumbnail',
        opacity: 1,
      },
      '-=400'
    );

  const blogFooterAnimation = function(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        articleTl.play();
        blogObserver.unobserve(entry.target);
      } else {
        articleTl.pause();
      }
    });
  };

  const blogOptions = {
    threshold: 0.7,
  };

  const blogObserver = new IntersectionObserver(
    blogFooterAnimation,
    blogOptions
  );

  const element = document.querySelectorAll('.js-observed');

  if (element) {
    element.forEach((target) => {
      blogObserver.observe(target);
    });
  }
}
